<template>
  <b-container>
    <h1>Configure</h1>
    <div class="jumobtron" style="border:1px solid #dadada; padding: 1rem;">
      <div>
        <h2>
          <input
            type="checkbox"
            class="inline-block"
            id="checkbox-1"
            v-model="enabledStatus"
            name="checkbox-1"
            true-value="true"
            false-value="false"
          />
          App Status<b
            v-b-tooltip.hover
            v-b-tooltip.html
            title="Use this toggle to enabled or disable Teacher Institute Registration"
            ><b-icon-info></b-icon-info
          ></b>
          <strong
            ><span
              v-if="enabledStatus == true || enabledStatus == 'true'"
              style="color: green !important;"
              >Enabled</span
            ><span
              v-if="enabledStatus == false || enabledStatus == 'false'"
              style="color: red !important;"
              >Disabled</span
            ></strong
          >
          <b-button v-on:click="saveEnabledStatus()">Save</b-button>
        </h2>
      </div>
      <hr />
      <p>
        The three text areas below are designed to allow you to edit the text on
        the content on the front page of Teacher Institute. The items are in the
        exact order, simply update the text and hit save.
      </p>

      <hr />

      <h2>Main Introduction text</h2>
      <ckeditor
        :config="editor1Config"
        id="editor2"
        v-model="mainIntroductionText[0].mainIntroductionText"
        rows="3"
        max-rows="6"
      ></ckeditor>

      <b-button v-on:click="saveIntro()" variant="outline-danger"
        >Save Introduction text</b-button
      >

      <h2>Course Cancellation Policy</h2>
      <ckeditor
        :config="editor2Config"
        id="textarea"
        v-model="cancellationPolicyText[0].cancellationPolicyText"
        rows="3"
        max-rows="6"
      ></ckeditor>
      <b-button v-on:click="saveCancellationPolicy()" variant="outline-danger"
        >Save Course Cancellation Policy</b-button
      >

      <h2>Tuition Discounts</h2>
      <ckeditor
        :config="editor3Config"
        id="textarea"
        v-model="tuitionDiscountText[0].tuitionDiscountText"
        rows="3"
        max-rows="6"
      ></ckeditor>
      <b-button v-on:click="saveTuitionDiscount()" variant="outline-danger"
        >Save Tuition Discount</b-button
      >

      <h2>Registration Disabled Text</h2>
      <ckeditor
        :config="editor4Config"
        id="textarea"
        v-model="disabledText[0].disabledText"
        rows="3"
        max-rows="6"
      ></ckeditor>
      <b-button v-on:click="saveDisabledText()" variant="outline-danger"
        >Save Registration Disabled Text</b-button
      >
    </div>
  </b-container>
</template>

<script>
import { mixins } from "../mixins";

export default {
  name: "Configure",
  mixins: [mixins],
  data() {
    return {
      editor1Config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "-",
            "Copy",
            "Paste",
            "PasteFromWord",
            "-",
            "Undo",
            "Redo",
            "-",
            "Link",
            "Unlink",
            "-",
            "NumberedList",
            "BulletedList",
            "Source",
          ],
        ],
      },
      editor2Config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "-",
            "Copy",
            "Paste",
            "PasteFromWord",
            "-",
            "Undo",
            "Redo",
            "-",
            "Link",
            "Unlink",
            "-",
            "NumberedList",
            "BulletedList",
            "Source",
          ],
        ],
      },
      editor3Config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "-",
            "Copy",
            "Paste",
            "PasteFromWord",
            "-",
            "Undo",
            "Redo",
            "-",
            "Link",
            "Unlink",
            "-",
            "NumberedList",
            "BulletedList",
            "Source",
          ],
        ],
      },
      editor4Config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "-",
            "Copy",
            "Paste",
            "PasteFromWord",
            "-",
            "Undo",
            "Redo",
            "-",
            "Link",
            "Unlink",
            "-",
            "NumberedList",
            "BulletedList",
            "Source",
          ],
        ],
      },
      enabledStatus: "false",
      mainIntroductionText: [],
      cancellationPolicyText: [],
      tuitionDiscountText: [],
      disabledText: [],
    };
  },
  created() {
    this.getEnabledStatus();
    this.getIntro();
    this.getCancellationPolicy();
    this.getTuitionDiscount();
    this.getDisabledText();
  },
  methods: {
    getEnabledStatus() {
      this.api.get("/enabledStatus").then((res) => {
        this.enabledStatus = res.data;
      });
    },
    getIntro() {
      this.api
        .get("/mainIntroductionText")
        .then((res) => {
          this.mainIntroductionText = res.data;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.mainIntroductionText = {
              title: "ERROR:",
            };
          } else {
            this.mainIntroductionText = {
              title: "ERROR:",
            };
          }
        });
    },
    getCancellationPolicy() {
      this.api
        .get("/cancellationPolicyText")
        .then((res) => {
          this.cancellationPolicyText = res.data;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.cancellationPolicyText = {
              title: "ERROR:",
            };
          } else {
            this.cancellationPolicyText = {
              title: "ERROR:",
            };
          }
        });
    },
    getTuitionDiscount() {
      this.api
        .get("/tuitionDiscountText")
        .then((res) => {
          this.tuitionDiscountText = res.data;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.tuitionDiscountText = {
              title: "ERROR:",
            };
          } else {
            this.tuitionDiscountText = {
              title: "ERROR:",
            };
          }
        });
    },
    getDisabledText() {
      this.api
        .get("/disabledText")
        .then((res) => {
          this.disabledText = res.data;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.disabledText = {
              title: "ERROR:",
            };
          } else {
            this.disabledText = {
              title: "ERROR:",
            };
          }
        });
    },
    saveIntro() {
      this.api
        .post("/secure/setMainIntroductionText", {
          mainIntroductionText: this.mainIntroductionText[0]
            .mainIntroductionText,
        })
        .then((response) => {
          this.successToast("Introduction Text has been saved!", response);
        })
        .catch((error) => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    },
    saveCancellationPolicy() {
      this.api
        .post("/secure/setCancellationPolicyText", {
          cancellationPolicyText: this.cancellationPolicyText[0]
            .cancellationPolicyText,
        })
        .then((response) => {
          this.successToast("Cancellation Policy has been saved!", response);
        })
        .catch((error) => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    },
    saveTuitionDiscount() {
      this.api
        .post("/secure/setTuitionDiscountText", {
          tuitionDiscountText: this.tuitionDiscountText[0].tuitionDiscountText,
        })
        .then((response) => {
          this.successToast("Tuition Discount text has been saved!", response);
        })
        .catch((error) => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    },
    saveDisabledText() {
      this.api
        .post("/secure/setDisabledText", {
          disabledText: this.disabledText[0].disabledText,
        })
        .then((response) => {
          this.successToast(
            "The Registration disabled text has been saved!",
            response
          );
        })
        .catch((error) => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    },
    saveEnabledStatus() {
      this.api
        .post("/secure/setEnabledStatus", {
          enabled: this.enabledStatus,
        })
        .then((response) => {
          this.successToast("Application status has been updated!", response);
        })
        .catch((error) => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    },
  },
};
</script>

<style>
.cke_source {
  color: #000 !important;
}
a:active,
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background-color: #fff !important;
}
.dropdown-item a {
  color: rgba(167, 25, 48, 1) !important;
}
</style>
